/**
 * Root class for all behavior scripts.
 * Defines all common properties which are necessary in every child behavior script.
 *
 * @author benjamin loesch, robert wüest
 *
 * @class Behavior
 * @constructor
 */
export class Behavior {
    constructor(parentobject) {
        /**
         * if true the behavior functionality is disabled
         * @property disable
         * @type {Boolean}
         * @default false
         */
        this.disable = false;
        this.parentObject = parentobject;
    }
    /**
     * Will be called once, when rendering starts
     *
     * @method init
     * @param {TraversalState} traversalState
     */
    init(traversalState) {
        return;
    }
    /**
     * Will be called on every render pass
     *
     * @method render
     * @param {TraversalState} traversalState
     */
    render(traversalState) {
        return;
    }
    /**
     * Will be called when rendering is stopped -> Maybe this never happens!
     *
     * @method exit
     * @param {TraversalState} traversalState
     */
    exit(traversalState) {
        return;
    }
}
//# sourceMappingURL=behavior.js.map